import Clarity from '@microsoft/clarity';
import {isProd, isSandbox} from './envHelper';

export const initClarity = () => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

  if (!projectId || (!isProd && !isSandbox)) {
    console.log('[Clarity] Not enabled for this environment');
    return;
  }

  const environment = isProd ? 'production' : 'staging';
  console.log(
    '[Clarity] Initializing with projectId:',
    projectId,
    'environment:',
    environment,
  );

  Clarity.init(projectId);
  Clarity.setTag('environment', environment);
  Clarity.setTag('deployment', environment);
};

export const tagClarityEvent = (
  eventName: string,
  properties?: Record<string, string>,
) => {
  if (!isProd && !isSandbox) return;

  try {
    if (properties) {
      Object.entries(properties).forEach(([key, value]) => {
        Clarity.setTag(key, value);
      });
    }
    Clarity.event(eventName);
  } catch (error) {
    console.warn('[Clarity] Error tracking event:', error);
  }
};

export const identifyClarityUser = (
  customId: string,
  customSessionId?: string,
  customPageId?: string,
  friendlyName?: string,
) => {
  if (!isProd && !isSandbox) return;

  try {
    Clarity.identify(customId, customSessionId, customPageId, friendlyName);
  } catch (error) {
    console.warn('[Clarity] Error identifying user:', error);
  }
};
